export default "__VITE_ASSET__4f82f16a__"